import PropTypes from 'prop-types';
import React from 'react';
import Loader from '../../common/loader';
const ProcessingIndicator = _ref => {
  let _ref$message = _ref.message,
    message = _ref$message === void 0 ? undefined : _ref$message;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "processing-indicator",
    style: {
      textAlign: 'center'
    }
  }, message ? /*#__PURE__*/React.createElement("h4", null, message) : '', /*#__PURE__*/React.createElement(Loader, null));
};
ProcessingIndicator.propTypes = {
  message: PropTypes.string
};
export default ProcessingIndicator;